export function initMediaCarousel() {
    const carousels = document.querySelectorAll('.media-carousel__container');

    carousels.forEach(carouselContainer => {
        const carousel = carouselContainer.querySelector<HTMLElement>('.carousel');
        const prevButton = carouselContainer.querySelector<HTMLButtonElement>('.carousel-prev');
        const nextButton = carouselContainer.querySelector<HTMLButtonElement>('.carousel-next');

        const fullscreenButton = carouselContainer.querySelector<HTMLButtonElement>('.carousel-fullscreen');
        const counter = carouselContainer.querySelector<HTMLElement>('.carousel-counter');
        const slides = carouselContainer.querySelectorAll<HTMLElement>('.carousel__slide');
        const totalSlides = slides.length;

        if (!carousel || !prevButton || !nextButton || !counter || !fullscreenButton) {
            return;
        }

        // Optional quick navigation a slides rendering ships as a <template> (see AdvertMediaCarouselSlides):
        // type buttons jump to the first slide of that type, anchor links whose target is missing are dropped.
        const navTemplate = carousel.querySelector<HTMLTemplateElement>('template.carousel-nav-template');
        const nav = navTemplate?.content.firstElementChild?.cloneNode(true) as HTMLElement | undefined;
        nav?.querySelectorAll<HTMLAnchorElement>('a[href^="#"]').forEach(link => {
            if (!document.getElementById(link.hash.slice(1))) {
                link.remove();
            }
        });
        const navButtons = nav?.querySelectorAll<HTMLButtonElement>('[data-slide-type]') ?? [];
        if (nav?.children.length) {
            carouselContainer.append(nav);
        }
        navButtons.forEach(button => {
            button.addEventListener('click', () => {
                const target = Array.from(slides).find(slide => slide.dataset.type === button.dataset.slideType);
                if (target) {
                    carousel.scrollTo({ left: target.offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
                }
            });
        });

        const scrollStep = () => {
            const slide = carousel.querySelector<HTMLElement>('.carousel__slide');
            return slide ? slide.offsetWidth : carousel.offsetWidth;
        };

        let currentSlideIndex = 0;

        const updateCarouselState = () => {
            const scrollLeft = carousel.scrollLeft;
            const clientWidth = carousel.clientWidth;

            

            // Update counter and active slide
            currentSlideIndex = 0;
            
                const scrollCenter = scrollLeft + clientWidth / 2;
                let minDistance = Infinity;
                slides.forEach((slide, index) => {
                    const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
                    const distance = Math.abs(scrollCenter - slideCenter);
                    if (distance < minDistance) {
                        minDistance = distance;
                        currentSlideIndex = index;
                    }
                });
            

                // Update buttons
            // Add a small tolerance (e.g., 1px) for floating point inaccuracies
            const atStart = currentSlideIndex === 0 || scrollLeft<= 1;
            const atEnd = currentSlideIndex === totalSlides - 1 || scrollLeft + clientWidth >= carousel.scrollWidth - 1;
            prevButton.disabled = atStart;
            nextButton.disabled = atEnd;
                

            slides.forEach((slide, index) => {
                if (index === currentSlideIndex) {
                    slide.classList.add('is-active');
                } else {
                    slide.classList.remove('is-active');
                }
            });

            counter.textContent = `${currentSlideIndex + 1} / ${totalSlides}`;

            const currentType = slides[currentSlideIndex]?.dataset.type;
            navButtons.forEach(button => {
                button.setAttribute('aria-pressed', String(button.dataset.slideType === currentType));
            });
        };

        // Slide width changes with fullscreen and the window, but scrollLeft keeps its pixel value -
        // put the slide that was showing back in view, or the strip lands on a neighbour (and the
        // visible slide stays transparent until the next scroll marks it active).
        const keepCurrentSlide = () => {
            const slide = slides[currentSlideIndex];
            if (slide) {
                carousel.scrollTo({ left: slide.offsetLeft - slides[0].offsetLeft, behavior: 'instant' });
            }
            updateCarouselState();
        };

        const setFullscreen = (on: boolean) => {
            carouselContainer.classList.toggle('is-fullscreen', on);
            keepCurrentSlide();
        };

        carousel.addEventListener('scroll', updateCarouselState);
        window.addEventListener('resize', keepCurrentSlide);
        carousel.scrollLeft = 0;
        setTimeout(() => {
            carousel.scrollLeft = 0;
            updateCarouselState();
        }, 100);

        nextButton.addEventListener('click', () => {
            carousel.scrollBy({ left: scrollStep(), behavior: 'smooth' });
        });

        prevButton.addEventListener('click', () => {
            carousel.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
        });

        fullscreenButton.addEventListener('click', () => {
            setFullscreen(!carouselContainer.classList.contains('is-fullscreen'));
        });

        // Like a modal: a click on the dark backdrop around the carousel closes it. Only the
        // container itself - clicks on the slides, arrows and counter land on its children.
        carouselContainer.addEventListener('click', (event) => {
            if (event.target === carouselContainer && carouselContainer.classList.contains('is-fullscreen')) {
                setFullscreen(false);
            }
        });

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && carouselContainer.classList.contains('is-fullscreen')) {
                setFullscreen(false);
            }
        });
    });
}
